
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  progresses: {}
};

const progressSlice = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    startProgress(state, action) {
      const { id } = action.payload;
      state.progresses[id] = { value: 0, isVisible: true, isError: false };
    },
    updateProgress(state, action) {
      const { id, value } = action.payload;
      if (state.progresses[id]) {
        state.progresses[id].value = value;
      }
    },
    setProgressError(state, action) {
      const { id } = action.payload;
      if (state.progresses[id]) {
        state.progresses[id].isError = true;
      }
    },
    finishProgress(state, action) {
      const { id } = action.payload;
      if (state.progresses[id]) {
        state.progresses[id].value = 100;
      }
    },
    clearProgress(state, action) {
      const { id } = action.payload;
      delete state.progresses[id];
    }
  }
});


export const {
  startProgress,
  updateProgress,
  setProgressError,
  finishProgress,
  clearProgress
} = progressSlice.actions;


export default progressSlice.reducer;
